import type { BlogPost } from '../types'

const post: BlogPost = {
  title: 'The Last Time',
  slug: 'the-last-time',
  category: 'The Last Time',
  date: '2025-05-16',
  image: 'https://dpnelson.com/wp-content/uploads/2025/05/TheLastTime.jpg',
  excerpt: 'Could this be the last time you do this? If so, how might that perspective change how you approach it?',
  body: `Could this be the last time you do this? If so, how might that perspective change how you approach it?

As we go through life, there are things we do. Once we die, we've done everything we ever did for the last time.

Everything is finite. Everything has an end.

If you're a parent, there will be (or has been) a last time you picked up your child. If you ever were a child (and I'm betting you were at one point), there was a last time your parent picked you up. And neither of you knew it was the last time. It just never happened again.

This perspective can help when you're exasperated. When your patience is thin. This argument. This trial. This ski trip. It might be the last time you have to endure it.

Let that poignance sink in. Let it inform your emotional landscape as you move through life.

See if gratitude emerges.

See if you approach the thing differently.

See how it makes you feel.`,
}

export default post
